/* A number of tenge with the spaces between the thousands */
export const money = value => {

    const number = parseInt(value)

    if (Number.isNaN(number)) {
        return "—"
    }

    return `${number.toLocaleString("ru-RU").replace(/,/g, " ")} ₸`
}

/* The price of a service as the client reads it: "5 000 ₸" or "5 000 — 8 000 ₸" */
export const priceText = item => {

    if (parseInt(item.isFixedPrice) === 0 && item.endPrice) {
        return `${parseInt(item.price).toLocaleString("ru-RU")} — ${money(item.endPrice)}`
    }

    return money(item.price)
}

/* Minutes as the master says them: "45 мин", "1 ч 30 мин" */
export const duration = value => {

    const minutes = parseInt(value)

    if (Number.isNaN(minutes) || minutes <= 0) {
        return "—"
    }

    const hours = Math.floor(minutes / 60)
    const rest = minutes % 60

    if (hours === 0) {
        return `${rest} мин`
    }

    if (rest === 0) {
        return `${hours} ч`
    }

    return `${hours} ч ${rest} мин`
}

/* The orders of the list */
export const SORTS = [
    { key: "new", text: "Новые" },
    { key: "popular", text: "Популярные" },
    { key: "price", text: "Дороже" },
    { key: "name", text: "А — Я" }
]

/* The statuses of the list */
export const STATUSES = [
    { key: "all", text: "Все" },
    { key: "none", text: "Без категории" },
    { key: "archived", text: "В архиве" }
]
